enum DigitalLendingPortalEnvironment {
  Testing = 'testing',
  Production = 'production'
}

export default DigitalLendingPortalEnvironment;
